<template>
    <!-- 职位列表 -->
    <vHierarchyList :postList="postList" v-if="flag"></vHierarchyList>
</template>
<script>
import vHierarchyList from '../../listComponent/jurisdiction/hierarchyListComponent.vue';
export default {
    name: 'hierarchyList',
    components: {
        vHierarchyList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                status: true,
                rank: true,
                department_rid: true,
                superior_rid: true,
                team_role: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>